import * as React from "react";
import {
  StringListEditor,
  type StringListEditorProps,
} from "./StringListEditor";

export function OrderTypeItemsEditor(
  props: Pick<
    StringListEditorProps,
    "value" | "onChange" | "disabled" | "inputId"
  >
) {
  return (
    <StringListEditor
      label="Tooltip Items"
      helperText="Add detailed output items (e.g., Digital Elevation Model, Canopy Height Model)"
      placeholder="Enter item name..."
      {...props}
    />
  );
}
